<template>
  <div>
    <router-link tag="div" class="item" v-for="item in data" :key="item.id" :to="'/systematic/'+item.id">
      <div class="col col-1">
        <img v-lazy="item.icon">
      </div>
      <div class="col col-2">
        <h4><span>{{item.section}}节</span><b v-html="item.title"></b></h4>
        <h5><span v-html="item.user_name"></span><span class="honor">{{item.user_honor}}</span></h5>
        <div class="xianshi" v-if="item.is_promotion">
          {{item.promotion_name}}&emsp;{{item.remaining}}
        </div>
        <div class="time" v-if="!item.is_promotion">
          <span>{{item.duration | format}}</span>
        </div>
        <div class="price">
          <div class="left">
            <span><i class="iconfont icon-weibiaoti4"></i>{{item.browses}}</span>
            <span><i class="iconfont icon-dianzan"></i>{{item.goods}}</span>
          </div>
          <div class="right" v-if="item.is_promotion"><s>¥{{item.price}}</s>¥{{item.promotion_price}}</div>
          <div class="right" v-else>¥{{item.price}}</div>
        </div>
      </div>
    </router-link>
  </div>
</template>
<script type="text/ecmascript-6">
import {getRemaining} from '@/utils/dateUtil.js'
export default {
  props: {
    data: {
      type: Array,
      default: null
    }
  },
  created() {
  },
  watch: {
    data(nv, ov) {
      nv.forEach((item, i) => {
        let end = item.promotion_enddate
        let now = Date.parse(new Date()) / 1000
        let seconds = end - now
        this.$set(item, 'remaining', getRemaining(seconds))
        setInterval(() => {
          seconds--
          this.$set(item, 'remaining', getRemaining(seconds))
        }, 1000)
      })
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .item{
    margin-top size(40)
    display flex
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    width 100%
    .col{
      display block
    }
    .col-1{
      width size(160)
      height size(190)
      position relative
      -webkit-border-radius: size(10)
      -moz-border-radius: size(10)
      border-radius: size(10)
      overflow hidden
      img{
        width 100%
        height 100%
      }
      .date{
        position absolute
        bottom: 0
        left: 0
        width: 100%
        height: size(36)
        line-height size(36)
        text-align center
        color #fff
        font-size size(22)
        background-color: rgba(0, 0, 0, .5)
      }
    }
    .col-2{
      width "calc(100% - %s)" % size(160)
      padding-left size(26)
      padding-top size(12)
      padding-bottom size(10)
      display: -webkit-box
      display: -webkit-flex
      display: -ms-flexbox
      display: flex
      -webkit-box-orient: vertical
      -webkit-box-direction: normal
      -webkit-flex-direction: column
      -ms-flex-direction: column
      flex-direction: column
      -webkit-box-pack: justify
      -webkit-justify-content: space-between
      -ms-flex-pack: justify
      justify-content: space-between
      h4{
        font-size size(32)
        width: 100%
        font-weight 900
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        line-height 1.2
        /*display: -webkit-box*/
        /*-webkit-line-clamp: 2*/
        /*-webkit-box-orient: vertical*/
        /*line-height 1.4*/
        span{
          display inline-block
          -webkit-border-radius: 10px
          -moz-border-radius: 10px
          border-radius: 10px
          border: 1px solid $color-theme
          color: $color-theme;
          font-size: size(20)
          padding: size(4) size(10) size(1)
          line-height 1
          margin-right: size(10)
          font-weight normal
          position relative
          top: -3px;
        }
      }
      .time{
        font-size size(24)
        color $color-text-l
        line-height 1.6//
      }
      h5{
        font-size size(28)
        line-height 1
        span{
          display inline-block
          margin-right: 5px
        }
        .honor{
          font-size: size(26)
          color: #666
          font-weight normal
        }
      }
      .position{
        height size(72 / 2)
        p{
          font-size size(26)
          line-height 1.4
          color $color-text-l
        // display: -webkit-box
        // -webkit-line-clamp: 2
        // -webkit-box-orient: vertical
          white-space nowrap
          text-overflow ellipsis
          overflow: hidden

        }
      }
      .xianshi{
        font-size: size(28)
        color: #ff3125;
        font-weight bold
      }

      .price{
        display table
        width 100%
        color: $color-text-l
        line-height 1
        >div{
          display table-cell
          vertical-align middle
          width 50%
        }
        .left{
          font-size: size(20)
          span{
            display inline-block
            i{
              font-size size(28)
              margin-right: 2px
            }
            i.icon-weibiaoti4{
              position relative
              top size(3)
            }
          }
        }
        .right{
          s{
            font-size: size(24)
            color: #999999
            font-weight normal
            padding-right: size(10)
          }
          text-align right
          font-size size(28)
          color $color-theme
          font-weight 900
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/systematic/systematic-card.vue